import React from "react";
import {
    Car,
    Clock,
    CarFront,
    Package,
    User,
    Route,
    Navigation as Compass,
    Heart,
} from "lucide-react";
import Innova from '../assets/carImages/Innova-removebg-preview.png'
import Innova_Crysta from '../assets/carImages/Innova_Crysta-removebg-preview.png'
import sedan from '../assets/carImages/sedan-removebg-preview.png'
import xylo from '../assets/carImages/xylo.jpeg'
import mini from '../assets/carImages/mini-removebg-preview.png'
import suzuki from '../assets/carImages/suzuki.jpeg'
import tempo from '../assets/carImages/Tempo-removebg-preview.png'
import marazo from '../assets/carImages/download (3).jpeg'
import tavera from  '../assets/carImages/tavera.jpeg'


// Cars Data - 8 vehicles
export const cars = [
    {
        id: 1,
        name: "Swift Dzire",
        type: "Sedan",
        price: "₹13/km",
        seats: 4,
        image: sedan,
        features: ["AC", "Comfort Seats", "GPS Navigation", "Fuel Efficient"],
        rating: 4.8,
        driverIncluded: true,
        color: "from-blue-500 to-cyan-400",
    },
    {
        id: 2,
        name: "Mahindra Xylo",
        type: "SUV",
        price: "₹17/km",
        seats: 8,
        image: xylo,
        features: ["Spacious", "Family Friendly", "Large Luggage Space", "AC"],
        rating: 4.7,
        driverIncluded: true,
        color: "from-emerald-500 to-teal-400",
    },
    {
        id: 3,
        name: "Mahindra Marazzo",
        type: "MPV",
        price: "₹17/km",
        seats: 8,
        image: marazo,
        features: [
            "Premium Comfort",
            "Entertainment System",
            "Climate Control",
            "Spacious",
        ],
        rating: 4.7,
        driverIncluded: true,
        color: "from-purple-500 to-pink-400",
    },
    {
        id: 4,
        name: "Chevrolet Tavera",
        type: "SUV",
        price: "₹19/km",
        seats: 8,
        image: tavera,
        features: ["Durable", "Comfortable", "Reliable", "AC"],
        rating: 4.6,
        driverIncluded: true,
        color: "from-orange-500 to-amber-400",
    },
    {
        id: 5,
        name: "Toyota Innova",
        type: "Premium SUV",
        price: "₹19/km",
        seats: 7,
        image: Innova,
        features: [
            "Premium Interior",
            "Advanced Safety",
            "Entertainment",
            "Comfort",
        ],
        rating: 4.9,
        driverIncluded: true,
        color: "from-red-500 to-rose-400",
    },
    {
        id: 6,
        name: "Toyota Innova Crysta",
        type: "Luxury SUV",
        price: "₹23/km",
        seats: 7,
        image: Innova_Crysta,
        features: [
            "Luxury Seats",
            "Premium Audio",
            "Climate Control",
            "Safety Features",
        ],
        rating: 4.9,
        driverIncluded: true,
        color: "from-indigo-500 to-violet-400",
    },
    {
        id: 7,
        name: "Tempo Traveller",
        type: "Group Vehicle",
        price: "₹24/km",
        seats: "12-15",
        image: tempo,
        features: ["Group Travel", "Spacious", "AC", "Comfort"],
        rating: 4.6,
        driverIncluded: true,
        color: "from-yellow-500 to-orange-400",
    },
    {
        id: 8,
        name: "Suzuki",
        type: "Luxury Tempo",
        price: "₹13/km",
        seats: "4-5",
        image: suzuki,
        features: [
            "Luxury Interior",
            "Entertainment",
            "Comfort Seats",
            "Spacious",
        ],
        rating: 4.8,
        driverIncluded: true,
        color: "from-green-500 to-emerald-400",
    },
];

export const services = [
    {
        id: "cab",
        title: "Cab Service",
        subtitle: "Premium Cars with Drivers",
        icon: <Car className="h-6 w-6" />,
        gradient: "from-blue-500 via-cyan-400 to-indigo-500",
        bgColor: "bg-gradient-to-br from-blue-500 via-cyan-400 to-indigo-500",
        color: "text-blue-600",
        description:
            "Professional cab service with per km billing and premium vehicles",
        features: [
            "Per km billing",
            "Hourly packages",
            "All vehicles",
            "24/7 support",
        ],
    },
    {
        id: "oneway",
        title: "One-Way Drop",
        subtitle: "Fixed Price Service",
        icon: <Route className="h-6 w-6" />,
        gradient: "from-purple-500 via-pink-400 to-rose-500",
        bgColor: "bg-gradient-to-br from-purple-500 via-pink-400 to-rose-500",
        color: "text-purple-600",
        description:
            "Fixed fare one-way drop service to all major destinations",
        features: [
            "No return charges",
            "Fixed pricing",
            "All routes",
            "Door-to-door",
        ],
    },
    {
        id: "driver",
        title: "Acting Driver",
        subtitle: "Professional Drivers",
        icon: <User className="h-6 w-6" />,
        gradient: "from-emerald-500 via-teal-400 to-green-500",
        bgColor: "bg-gradient-to-br from-emerald-500 via-teal-400 to-green-500",
        color: "text-emerald-600",
        description:
            "Expert acting drivers for your personal or rental vehicles",
        features: [
            "Verified drivers",
            "Route experts",
            "Professional",
            "Flexible hours",
        ],
    },
    {
        id: "rental",
        title: "Car Rental",
        subtitle: "Flexible Packages",
        icon: <Package className="h-6 w-6" />,
        gradient: "from-orange-500 via-amber-400 to-yellow-500",
        bgColor:
            "bg-gradient-to-br from-orange-500 via-amber-400 to-yellow-500",
        color: "text-orange-600",
        description: "Flexible car rental packages with premium vehicles",
        features: [
            "Hourly & daily",
            "All vehicles",
            "Airport service",
            "City tours",
        ],
    },
];

export const stats = [
    {
        number: "50+",
        label: "Premium Vehicles",
        icon: <CarFront className="h-5 w-5" />,
        color: "from-blue-500 to-cyan-500",
    },
    {
        number: "100+",
        label: "Expert Drivers",
        icon: <User className="h-5 w-5" />,
        color: "from-emerald-500 to-teal-500",
    },
    {
        number: "24/7",
        label: "Service Available",
        icon: <Clock className="h-5 w-5" />,
        color: "from-purple-500 to-pink-500",
    },
    {
        number: "5000+",
        label: "Happy Customers",
        icon: <Heart className="h-5 w-5" />,
        color: "from-rose-500 to-red-500",
    },
];
